<template>
  <div class="vx-col w-full mb-base m-auto">
    <vx-card title="Payments history">
      <div class="mb-5 word-custom">
        <vs-table :data="paymentList" pagination max-items="10">
          <template slot="thead">
            <vs-th sort-key="createdAt">Date</vs-th>
            <vs-th sort-key="createdAt">Time</vs-th>
            <vs-th sort-key="id">Invoice Id</vs-th>
            <vs-th>Org. name</vs-th>
            <vs-th>Plan name</vs-th>
            <vs-th>Plan Type</vs-th>
            <vs-th>Amount</vs-th>
            <!-- <vs-th >Pay Amount</vs-th>
            <vs-th >Starting Balance</vs-th>
            <vs-th >Ending Balance</vs-th>-->
            <vs-th>Invoice</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="tr_index" v-for="(tr, tr_index) in data">
              <vs-td>{{ tr.createdAt | moment("DD/MM/YYYY") }}</vs-td>
              <vs-td>{{ tr.createdAt | moment("h:mm:ss a") }}</vs-td>
              <vs-td>
                <a :href="tr.invoice_url" target="_blank">{{ tr.id }}</a>
              </vs-td>
              <vs-td>{{ tr.organization_id?tr.organization_id.name:"" | capitalize }}</vs-td>
              <vs-td>{{ tr.plan_id.plan_name | capitalize }}</vs-td>
              <vs-td>
                <span v-if="tr.period == 'M'">Monthly</span>
                <span v-if="tr.period == 'Q'">Quarterly</span>
                <span v-if="tr.period == 'Y'">Yearly</span>
                <span v-if="tr.period == 'D'">Free plan</span>
              </vs-td>
              <vs-td>
                <span
                  v-if="tr.period == 'M'"
                >{{ tr.plan_id.price_per_month ? tr.plan_id.price_per_month : 'N/A' }}</span>
                <span
                  v-if="tr.period == 'Q'"
                >{{ tr.plan_id.price_per_quarter ? tr.plan_id.price_per_quarter : 'N/A' }}</span>
                <span
                  v-if="tr.period == 'Y'"
                >{{ tr.plan_id.price_per_year ? tr.plan_id.price_per_year : 'N/A' }}</span>
                <span v-if="tr.period == 'D'">free plan</span>
              </vs-td>
              <!-- <vs-td>{{ converInRS(tr.amount_paid) }}</vs-td>
              <vs-td>{{ converInRS(tr.starting_balance) }}</vs-td>
              <vs-td>{{ converInRS(tr.ending_balance) }}</vs-td>-->
              <vs-td>
                <a :href="tr.invoice_url" target="_blank">
                  <vs-button
                    color="#4285F4"
                    type="filled"
                    class="mr-2 mb-2 float-left"
                    icon-pack="feather"
                    icon="icon-eye"
                    size="small"
                    title="View Invoice"
                  ></vs-button>
                </a>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      paymentList: []
    };
  },
  created() {
    if (
      this.$store.state.uInfo.role !== "SA" &&
      this.$store.state.uInfo.role !== "CA"
    ) {
      history.back();
    }
  },
  mounted() {
    this.getPaymentsHistory();
  },
  methods: {
    converInRS(amount) {
      let a = parseFloat(amount) / 100;
      return a;
    },
    getPaymentsHistory() {
      this.$vs.loading({ color: "primary" });
      let url = "invoiceListing";

      if (this.$store.state.uInfo.role == "CA") {
        url += "?org_id=" + this.$store.state.uInfo.organization;
      }

      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          this.$store.state.is_new_plan = data[0].is_new_plan;

          this.paymentList = data;
        })
        .catch(e => {
          this.showError(e);
        });
    }
  }
};
</script>
		